import { FacetValue, FacetValues } from '../../../types/Facet';
import { Field } from '../../../types/Field';
import './FecetFilters.scss';
import { useState } from 'react';

const FacetFilters = ({ selectedFacetsValues, fields, clearGroupFilter }: { selectedFacetsValues: FacetValues<FacetValue>[]; fields: Field[]; clearGroupFilter: (facetName: string) => void }) => {
    const [showTooltip, setTooltipFlag] = useState(false);
    const filters = selectedFacetsValues.map((facetValues: FacetValues<FacetValue>, i: number) => {
         let facetFilterDisplayValue = '';
    
        const field = fields.find((field: Field) => field.name === facetValues.facetName);
        if (!field) {
            throw new Error(`Field with name ${facetValues.facetName} not found in fields array.`);
        }

        const facetDisplayName = field.userSettings.displayName;;
        facetValues.facetValues.forEach((facetValue: FacetValue) => {
            if (facetFilterDisplayValue.length !== 0) {
                facetFilterDisplayValue = facetFilterDisplayValue + ', ' + facetValue.getDisplayValue();
            } else {
                facetFilterDisplayValue = facetValue.getDisplayValue();
            }
        });

        const tooltipMouseEnter = (key: any) => {
            let elementDiv = document.getElementById('div-' + key);

            let scrollWidth = elementDiv?.scrollWidth;
            let offsetWidth = elementDiv?.offsetWidth;

            if (scrollWidth !== undefined && offsetWidth !== undefined && scrollWidth > offsetWidth) {
                setTooltipFlag(true);
            } else {
                setTooltipFlag(false);
            }
        };

        return (
            <li className="filter-data-list" key={facetValues.facetName}>
                <div title={facetDisplayName} className="filter-data-div">
                    {facetDisplayName}  
                </div>
                <div
                    id={`div-${facetValues.facetName}`}
                    title={showTooltip ? facetFilterDisplayValue : ''}
                    className="filter-values-div"
                    onMouseEnter={() => tooltipMouseEnter(facetValues.facetName)}
                >
                    : &nbsp; <b>{facetFilterDisplayValue}</b>
                </div>
                <div className="close-filter-icon material-icons" title="Close" onClick={() => clearGroupFilter(facetValues.facetName)}>
                    close
                </div>
            </li>
        );
    });

    return <ul>{filters}</ul>;
};

export default FacetFilters;
